import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerSeleccionOrden = styled(motion.div)`
  width: 100%;
  height: calc(100vh - 25vh);
  height: calc(100dvh - 25dvh);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 14px;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
`;

/* Encabezado: instrucción al paciente. Es la primera lectura, más jerarquía.
   En terminal el tamaño se controla con la clase tipográfica del span (rb24m). */
export const HeaderTexto = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 24px auto 8px auto;
  color: var(--color-latex10);
  text-align: center;
  padding: 0 18px;

  span {
    line-height: 1.45;
    ${({ $isTerminal }) => (!$isTerminal ? "font-size: 17px;" : "")}
  }

  @media (min-width: 768px) {
    padding: 0 32px;
    span {
      ${({ $isTerminal }) => (!$isTerminal ? "font-size: 18px;" : "")}
    }
  }
`;

/* Título secundario antes de la lista de prestaciones. Tipografía más
   discreta que el HeaderTexto (subordinada). */
export const TituloPrestaciones = styled.p`
  margin: 16px 0 6px 0;
  text-align: center;
  color: var(--color-latex10);
  font-size: ${({ $isTerminal }) => ($isTerminal ? "20px" : "14px")};
  letter-spacing: 0.2px;
  opacity: 0.75;
`;

/* Wrapper que reescala el ResumenLista (íconos 37px + rb18m) a un tamaño más
   compacto adecuado para una lista de chequeo. En terminal se agranda para
   que sea legible a distancia. */
export const PrestacionesCompact = styled.div`
  margin-bottom: 4px;

  > div {
    /* sobreescribe el padding-left del ResumenLista para centrar mejor */
    padding-left: 0;
    align-items: center;
  }

  > div > div {
    /* cada Item: gap más justo, ancho automático */
    width: auto !important;
    max-width: 480px;
    gap: 10px !important;
    margin-top: 8px !important;
  }

  svg {
    width: ${({ $isTerminal }) => ($isTerminal ? "28px" : "20px")};
    height: ${({ $isTerminal }) => ($isTerminal ? "28px" : "20px")};
    flex-shrink: 0;
  }

  span {
    font-size: ${({ $isTerminal }) =>
      $isTerminal ? "20px !important" : "14px !important"};
    line-height: 1.3;
    text-align: left;
  }

  @media (min-width: 768px) {
    span {
      font-size: ${({ $isTerminal }) =>
        $isTerminal ? "22px !important" : "15px !important"};
    }
  }
`;

export const ListaOrdenes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 14px 20px 14px;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    padding: 20px 24px 28px 24px;
  }
`;

export const AccionesPie = styled.div`
  width: max-content;
  height: max-content;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-height: 700px) {
    padding-bottom: 30px;
    padding-top: 20px;
  }

  .btn-principal {
    width: 100%;
    min-width: 220px;
    max-width: 330px;
    height: 44px;
    background: var(--color-latex30);
    color: var(--color-white);
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    padding: 0 18px;
  }

  .btn-principal[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .btn-secundario {
    width: 100%;
    min-width: 220px;
    max-width: 330px;
    height: 39px;
    background: var(--color-white);
    color: var(--color-latex30);
    border: 2px solid var(--color-latex30);
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-secundario[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Card con el mismo look que CardCheck: header azul con círculo naranja+tilde
// y cuerpo blanco con la info. Se selecciona clickeando toda la card.
export const CardOrdenSelectable = styled.div`
  width: 333px;
  min-height: 150px;
  border-radius: 16px;
  background: var(--color-white);
  box-shadow:
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  border: 2px solid transparent;
  transition: ease-in-out 0.3s;
  cursor: pointer;
  overflow: hidden;

  &.selected {
    border-color: #ff6600;
  }

  &.fija {
    cursor: default;
  }
`;

export const CardOrdenTop = styled.div`
  width: 100%;
  height: 45px;
  background: var(--color-secondary-gradient);
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 10px;

  .circle-orange {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background: ${({ $active }) =>
      $active ? "var(--color-primary)" : "var(--color-white)"};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    flex-shrink: 0;
    transition: ease-in-out 0.3s;
  }

  h1 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    color: var(--color-white);
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .badge-asignada {
    font-size: 11px;
    background: var(--color-white);
    color: var(--color-latex30);
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;
    flex-shrink: 0;
  }
`;

export const CardOrdenBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 10px 14px;

  p {
    margin: 0;
    font-size: 16px;
  }
`;
